(function () {
  function isVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return el.getBoundingClientRect().height > 0;
  }

  function measureHeaderGroupHeight() {
    var sections = document.querySelectorAll('.shopify-section-group-header-group');
    var desktop = window.innerWidth >= 1025;
    var height = 0;
    var announcementHeight = 0;

    sections.forEach(function (section) {
      var isMobileHeader = section.classList.contains('section-header-mobile');
      var isDesktopNav = section.classList.contains('section-header-navigation');

      if (desktop && isMobileHeader) return;
      if (!desktop && isDesktopNav) return;
      if (!isVisible(section)) return;

      var sectionHeight = Math.round(section.getBoundingClientRect().height);
      height += sectionHeight;

      if (!isMobileHeader && !isDesktopNav) {
        // Floor on mobile so sticky top never sits below the promo bar (avoids 1px scroll gap)
        announcementHeight = desktop
          ? sectionHeight
          : Math.floor(section.getBoundingClientRect().height);
      }
    });

    if (height > 0) {
      document.documentElement.style.setProperty('--yazli-header-group-height', height + 'px');
    }
    document.documentElement.style.setProperty(
      '--yazli-announcement-height',
      announcementHeight + 'px'
    );
  }

  function measureMobileToolbarHeight() {
    var toolbar = document.querySelector('.halo-sticky-toolbar-mobile');
    var height = 0;
    if (toolbar && window.innerWidth < 1025 && isVisible(toolbar)) {
      height = Math.ceil(toolbar.getBoundingClientRect().height);
    }
    document.documentElement.style.setProperty(
      '--yazli-mobile-toolbar-height',
      (height || 66) + 'px'
    );
  }

  function updateHeaderSolidState() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.classList.toggle('yazli-header-scrolled', scrollTop > 24);
  }

  function applyDesktopWhiteLogo() {
    if (!window.yazliLogoWhiteUrl || window.innerWidth < 1025) return;
    document.querySelectorAll('.header-nav-hamburger .header__heading-logo.logo__main').forEach(function (img) {
      if (img.dataset.yazliLogoApplied === '1') return;
      img.dataset.yazliLogoApplied = '1';
      img.src = window.yazliLogoWhiteUrl;
      img.removeAttribute('srcset');
    });
  }

  function refresh() {
    measureHeaderGroupHeight();
    measureMobileToolbarHeight();
    updateHeaderSolidState();
    applyDesktopWhiteLogo();
  }

  window.addEventListener('scroll', updateHeaderSolidState, { passive: true });
  window.addEventListener('resize', refresh);
  window.addEventListener('load', refresh);
  document.addEventListener('DOMContentLoaded', refresh);

  function getHeaderOffset() {
    return (
      parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          '--yazli-header-group-height'
        ),
        10
      ) || 100
    );
  }

  function getMobileToolbarOffset() {
    if (window.innerWidth >= 1025) return 0;
    return (
      parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
          '--yazli-mobile-toolbar-height'
        ),
        10
      ) || 66
    );
  }

  function scrollToFeaturedPerfumes() {
    var target = document.getElementById('yazli-featured-perfumes');
    if (!target) return false;

    measureHeaderGroupHeight();
    measureMobileToolbarHeight();

    var headerOffset = getHeaderOffset();
    var toolbarOffset = getMobileToolbarOffset();
    var firstCard = target.querySelector('[class*="ai-new-arrivals-product-card"]');
    var firstButtons = target.querySelector('[class*="ai-new-arrivals-buttons"]');

    // Show the full perfume card (image + info + Add to Cart), not just the title.
    if (firstCard && firstButtons) {
      var cardTop = firstCard.getBoundingClientRect().top + window.pageYOffset;
      var buttonsBottom =
        firstButtons.getBoundingClientRect().bottom + window.pageYOffset;
      var available =
        window.innerHeight - headerOffset - toolbarOffset - 20;
      var cardSpan = buttonsBottom - cardTop;
      var scrollTop;

      if (cardSpan <= available) {
        scrollTop = cardTop - headerOffset - 16;
      } else {
        // Card taller than viewport: keep Add to Cart visible near bottom.
        scrollTop =
          buttonsBottom - (window.innerHeight - toolbarOffset - 20);
      }

      window.scrollTo({ top: Math.max(0, scrollTop), behavior: 'smooth' });
    } else {
      var y =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        headerOffset -
        12;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }

    if (history.replaceState) {
      history.replaceState(null, '', '#yazli-featured-perfumes');
    }
    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.yazli-side-cart__continue');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    if (href.indexOf('#yazli-featured-perfumes') === -1) return;

    event.preventDefault();
    document.body.classList.remove('cart-sidebar-show');
    document.documentElement.classList.remove('cart-sidebar-show');

    window.setTimeout(function () {
      if (scrollToFeaturedPerfumes()) return;
      window.location.href = href;
    }, 180);
  });

  function handleFeaturedHashOnLoad() {
    if (window.location.hash !== '#yazli-featured-perfumes') return;
    window.setTimeout(scrollToFeaturedPerfumes, 250);
  }

  window.addEventListener('load', handleFeaturedHashOnLoad);
  document.addEventListener('DOMContentLoaded', handleFeaturedHashOnLoad);

  /* Product gallery: thumb click → main image (desktop + mobile) */
  function initProductGalleryThumbs() {
    if (!document.body.classList.contains('template-product')) return;

    document.querySelectorAll('[data-image-gallery]').forEach(function (gallery) {
      if (gallery.getAttribute('data-yazli-gallery-ready')) return;
      gallery.setAttribute('data-yazli-gallery-ready', '1');

      gallery.addEventListener(
        'click',
        function (e) {
          if (e.target.closest('.slick-arrow')) return;

          var thumb = e.target.closest('.productView-thumbnail');
          if (!thumb || !gallery.contains(thumb)) return;

          var nav = gallery.querySelector('.productView-nav');
          var thumbsRail = thumb.closest('.productView-for');
          if (!nav) return;

          var mediaAttr = thumb.getAttribute('data-media-id') || '';
          var mediaMatch = mediaAttr.match(/(\d+)\s*$/);
          var mediaId = mediaMatch ? mediaMatch[1] : '';
          var $ = window.jQuery;

          if ($ && $(nav).hasClass('slick-initialized')) {
            var goTo = NaN;
            if (mediaId) {
              var $match = $(nav)
                .find('.slick-slide:not(.slick-cloned) [data-media-id="' + mediaId + '"]')
                .closest('.slick-slide')
                .first();
              if ($match.length) goTo = parseInt($match.attr('data-slick-index'), 10);
            }
            if (isNaN(goTo)) {
              var raw = thumb.getAttribute('data-slick-index');
              goTo = raw != null && raw !== '' ? parseInt(raw, 10) : NaN;
            }
            if (!isNaN(goTo)) {
              e.preventDefault();
              $(nav).slick('slickGoTo', goTo);
              if (thumbsRail && $(thumbsRail).hasClass('slick-initialized')) {
                $(thumbsRail).slick('slickGoTo', goTo);
              }
            }
            return;
          }

          if (!mediaId) return;
          e.preventDefault();
          nav.querySelectorAll('.productView-image').forEach(function (slide) {
            var midEl = slide.querySelector('[data-media-id]');
            var id = midEl ? midEl.getAttribute('data-media-id') : '';
            var on = id === mediaId;
            slide.style.display = on ? '' : 'none';
            slide.classList.toggle('is-active', on);
          });
          gallery.querySelectorAll('.productView-thumbnail').forEach(function (t) {
            t.classList.toggle('is-active', t === thumb);
            t.classList.toggle('slick-current', t === thumb);
          });
        },
        true
      );
    });
  }

  document.addEventListener('DOMContentLoaded', initProductGalleryThumbs);
  document.addEventListener('shopify:section:load', initProductGalleryThumbs);
  window.addEventListener('load', initProductGalleryThumbs);

  /* ——— Site-wide loading spinner for ATC / Buy Now / cart / page nav ——— */
  var YAZLI_LOADABLE =
    '[data-btn-addtocart], [data-btn-addToCart], #product-add-to-cart, #product-sticky-add-to-cart, ' +
    'button.product-form__submit, button[name="add"], .yazli-coll__atc, [data-yazli-coll-atc], ' +
    '.yazli-pcard__atc, [data-yazli-pcard-atc], ' +
    '.yazli-bo__atc, [data-modal-add-to-cart], [data-modal-buy-now], [data-buy-now], ' +
    '[class*="ai-new-arrivals-add-to-cart"], [class*="ai-new-arrivals-button"], ' +
    '[data-yazli-bundle-upgrade], [data-yazli-perfume-select], .yazli-bm__option, ' +
    '#cart-checkout, #cart-sidebar-checkout, .button-checkout, [data-cart-remove], ' +
    '.previewCartItem-remove, .yazli-cart-item__remove, ' +
    '.shopify-payment-button__button, .shopify-payment-button__button--unbranded';

  var YAZLI_PAGE_LOAD_BTNS =
    '#cart-checkout, #cart-sidebar-checkout, .button-checkout, [data-modal-buy-now], [data-buy-now], ' +
    '.shopify-payment-button__button, .shopify-payment-button__button--unbranded';

  var yazliLoadingTimers = new WeakMap();
  var yazliPageLoadTimer = null;
  var yazliPageLoadHideTimer = null;

  function yazliEnsureGlobalLoader() {
    var el = document.getElementById('yazli-global-loader');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'yazli-global-loader';
    el.className = 'yazli-global-loader';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML =
      '<div class="yazli-global-loader__veil"></div>' +
      '<div class="yazli-global-loader__panel" role="status" aria-live="polite">' +
      '<span class="yazli-global-loader__spin" aria-hidden="true"></span>' +
      '</div>';
    (document.body || document.documentElement).appendChild(el);
    return el;
  }

  function yazliShowPageLoading(force) {
    yazliEnsureGlobalLoader();
    document.documentElement.classList.add('yazli-page-loading');
    document.body && document.body.classList.add('yazli-page-loading');
    if (yazliPageLoadHideTimer) {
      clearTimeout(yazliPageLoadHideTimer);
      yazliPageLoadHideTimer = null;
    }
    if (yazliPageLoadTimer) clearTimeout(yazliPageLoadTimer);
    // Always auto-clear as a safety net (navigation may be cancelled)
    yazliPageLoadTimer = setTimeout(function () {
      yazliHidePageLoading();
    }, force ? 20000 : 12000);
  }

  function yazliHidePageLoading() {
    if (yazliPageLoadTimer) {
      clearTimeout(yazliPageLoadTimer);
      yazliPageLoadTimer = null;
    }
    document.documentElement.classList.remove('yazli-page-loading');
    document.body && document.body.classList.remove('yazli-page-loading');
  }

  function yazliClearLoading(el) {
    if (!el) return;
    el.classList.remove('is-loading', 'yazli-loading');
    el.removeAttribute('aria-busy');
    var t = yazliLoadingTimers.get(el);
    if (t) {
      clearTimeout(t);
      yazliLoadingTimers.delete(el);
    }
  }

  function yazliSetLoading(el, ms) {
    if (!el) return;
    el.classList.add('is-loading', 'yazli-loading');
    el.setAttribute('aria-busy', 'true');
    var prev = yazliLoadingTimers.get(el);
    if (prev) clearTimeout(prev);
    yazliLoadingTimers.set(
      el,
      setTimeout(function () {
        yazliClearLoading(el);
        yazliHidePageLoading();
      }, ms || 12000)
    );
  }

  window.yazliSetLoading = yazliSetLoading;
  window.yazliClearLoading = yazliClearLoading;
  window.yazliShowPageLoading = yazliShowPageLoading;
  window.yazliHidePageLoading = yazliHidePageLoading;

  function yazliIsNavigationalLink(a) {
    if (!a || a.tagName !== 'A') return false;
    if (a.target && a.target !== '_self') return false;
    if (a.hasAttribute('download')) return false;
    if (a.getAttribute('aria-disabled') === 'true') return false;
    if (a.hasAttribute('data-cart-sidebar')) return false;
    if (a.hasAttribute('data-search-mobile')) return false;
    if (a.hasAttribute('data-open-auth-sidebar')) return false;
    if (a.hasAttribute('data-open-hamburger-menu')) return false;
    if (a.hasAttribute('data-bar-content')) return false;
    if (a.hasAttribute('data-close-content-sidebar')) return false;
    if (a.hasAttribute('data-search-close-sidebar')) return false;
    if (a.classList.contains('needsclick')) return false;

    var href = a.getAttribute('href');
    if (!href || href === '#' || href.indexOf('javascript:') === 0) return false;
    if (href.charAt(0) === '#') return false;

    try {
      var url = new URL(a.href, window.location.origin);
      if (url.origin !== window.location.origin) return false;
      if (
        url.pathname === window.location.pathname &&
        url.search === window.location.search &&
        url.hash
      ) {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }

  // First click → clear spinner on buttons / page nav / ATC
  document.addEventListener(
    'click',
    function (event) {
      if (event.defaultPrevented) return;
      if (event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var btn = event.target.closest(YAZLI_LOADABLE);
      if (btn) {
        if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
        if (btn.classList.contains('btn-unavailable')) return;

        yazliSetLoading(btn, 12000);

        // Show global veil on ATC / checkout so the first click is always obvious
        if (btn.matches(YAZLI_PAGE_LOAD_BTNS)) {
          yazliShowPageLoading();
          // Soft ATC actions: hide veil shortly after cart updates (handled below)
          yazliPageLoadHideTimer = setTimeout(yazliHidePageLoading, 8000);
        }
        return;
      }

      var link = event.target.closest('a[href]');
      if (yazliIsNavigationalLink(link)) {
        yazliShowPageLoading(true);
      }
    },
    true
  );

  // Form submits (search, filters, contact, etc.)
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      if (form.getAttribute('data-yazli-no-loader') != null) return;
      // Skip predictive search typing forms that stay on-page without navigation
      if (form.closest('predictive-search') && !event.submitter) return;
      yazliShowPageLoading(true);
      var submitBtn = form.querySelector('[type="submit"], button:not([type]), .button[type="submit"]');
      if (submitBtn) yazliSetLoading(submitBtn, 15000);
    },
    true
  );

  function yazliClearAllLoadable() {
    document.querySelectorAll('.is-loading, .yazli-loading').forEach(yazliClearLoading);
    yazliHidePageLoading();
  }

  document.addEventListener('cart-update', function () {
    window.setTimeout(yazliClearAllLoadable, 200);
  });
  document.addEventListener('cart:updated', function () {
    window.setTimeout(yazliClearAllLoadable, 200);
  });

  window.addEventListener('pageshow', function () {
    yazliClearAllLoadable();
  });
  window.addEventListener('load', function () {
    yazliHidePageLoading();
  });

  // Initial page load: show spinner if document is still loading
  if (document.readyState !== 'complete') {
    yazliShowPageLoading();
  }

  // Homepage-style ATC on search / predictive cards
  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest('[data-yazli-pcard-atc]');
      if (!btn || btn.disabled) return;
      event.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      yazliSetLoading(btn, 12000);
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          document.dispatchEvent(new CustomEvent('cart:updated'));
          if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
          } else if (window.Shopify && typeof Shopify.getCart === 'function' && window.sharedFunctions) {
            Shopify.getCart(function (cart) {
              document.body.classList.add('cart-sidebar-show');
              window.sharedFunctions.updateSidebarCart(cart);
            });
          }
        })
        .catch(function (err) {
          console.error(err);
        })
        .finally(function () {
          btn.disabled = false;
          yazliClearLoading(btn);
        });
    },
    true
  );

  // Clear ATC spinner when side cart finishes opening / refreshing
  if (typeof MutationObserver !== 'undefined') {
    var cartObs = new MutationObserver(function () {
      if (document.body.classList.contains('cart-sidebar-show')) {
        window.setTimeout(yazliClearAllLoadable, 350);
      }
    });
    cartObs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  refresh();
})();
